import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const SignUpFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    appbar: {
      padding: "40px 20px",
      display: "flex",
      alignItems: "space-between",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        padding: "0px 20px",
      },
    },
    loginLinkStyle: {
      color: "#fc4c4c", //text color
      fontSize: 14,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      width: "100vw",
      maxWidth: "600px",
      [theme.breakpoints.down("md")]: {
        padding: "0px 15px",
      },
    },
    root: {
      border: "1px solid #fff", //border color
      borderRadius: 16,
      "& .MuiInputBase-input": {
        color: "#002035", // text input
        fontSize: "16px",
        padding: "16px",
        "&:-webkit-autofill": {
          transitionDelay: "9999s",
          transitionProperty: "background-color, color",
        },
      },
      "& .MuiFilledInput-root": {
        border: "1px solid white", //border color
        borderRadius: 16,
        backgroundColor: "#F8F9F9",
        paddingTop: "8px",
        padingLeft: "8px",
        height: "54px",
      },
      "& .MuiFormLabel-root": {
        marginTop: "0px",
        fontWeight: 400, // Text input size
      },
      "& .MuiFormLabel-root.MuiInputLabel-shrink": {
        backgroundColor: "#fff",
        color: "#002035",
        padding: "2px",
        marginTop: "-18px",
      },
      "& .MuiFilledInput-root.Mui-focused": {
        border: "1px solid #002035", //border color
        borderRadius: 16,
      },
      "& label.Mui-focused": {
        color: "#8D9DA7",
      },
      "& .MuiFormHelperText-root.Mui-error": {
        fontSize: "14px",
        margin: "5px 0px",
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        fontSize: "14px",
        margin: "5px 0px",
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.error.main,
      },
      "& .MuiFormLabel-root.Mui-error": {
        fontSize: "16px",
        fontWeight: theme.typography.fontWeightMedium,
        color: "#8D9DA7",
      },
      "& .MuiFilledInput-root.Mui-error": {
        border: "1px solid #FC4C4C", //border color
        backgroundColor: "#FFF6F6",
        fontSize: "16px",
        fontWeight: theme.typography.fontWeightMedium,
        color: "#8D9DA7",
      },
      "& p.css-14ieswp-MuiFormHelperText-root": {
        paddingTop: "6px",
        margin: "10px 0px",
        fontSize: "14px",
        fontWeight: theme.typography.fontWeightMedium,
        color: "#8D9DA7",
      },
      "& .css-14ieswp-MuiFormHelperText-root.Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFilledInput-root:hover": {
        border: "1px solid #002035", //border color
        borderRadius: 16,
      },
    },
    label: {
      color: "#8D9DA7", //text color
      fontSize: "16px",
      fontWeight: "500",
      marginTop: "7px",
    },
    textField: {
      marginBottom: "20px",
    },
    stateSelector: {
      [theme.breakpoints.down("md")]: {
        padding: "16px 0px",
      },
    },
    termsOfUse: {
      color: "#7B858B",
      fontSize: "14px",
      textAlign: "center",
    },
    logoBox: {
      textAlign: "center",
      marginBottom: "28px",
      maxWidth: "559px",
      justifyContent: "center",
      color: theme.palette.primary.main,
      fontSize: "28px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "34px",
      letterSpacing: "-0.56px",
    },
    disclaimer: {
      maxWidth: "600px",
      display: "flex",
      padding: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "center",
      marginBottom: "15px",
      borderRadius: "10px",
      backgroundColor: "#FEFCF8",
    },
    disclosureContent: {
      color: "#7B858B",
      fontSize: "11px",
    },
    notSupported: {
      display: "flex",
      padding: "16px 0px",
      maxWidth: "590px",
      [theme.breakpoints.down("md")]: {
        maxWidth: "560px",
      },
    },
    notSupportedText: {
      color: "#FC4C4C",
      fontSize: "16px",
      fontFamily: "Söhne",
      lineHeight: "20px",
      fontWeight: 400,
      textAlign: "left",
      wordSpacing: "0.2em",
      [theme.breakpoints.down("md")]: {
        textAlign: "justify",
      },
      [theme.breakpoints.down("sm")]: {
        wordSpacing: "0",
        fontSize: "14px",
      },
    },
    button: {
      textTransform: "none",
      marginTop: "15px",
      height: "48px",
      background: theme.palette.secondary.main,
      color: "#fff",
      borderRadius: "16px",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "22px",
      "&:hover": {
        borderRadius: "16px",
        background: "#FEDBDB",
        boxShadow: "none",
      },
    },
  }),
);
